/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var _defineProperty = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.style = exports.name = exports.mapStateToProps = exports.TitleBar = void 0;

var react_1 = __importDefault(require("react"));

var brightsmith_core_1 = require("brightsmith-core");

var StyleUtils_1 = __importDefault(require("./utils/StyleUtils"));

var BrightsmithDb = brightsmith_core_1.Db.BrightsmithDb;
var name = 'TitleBar';
exports.name = name;

var TitleBar = function TitleBar(_ref) {
  var Frame = _ref.Frame,
      Text = _ref.Text,
      Image = _ref.Image,
      styles = _ref.styles;
  return /*#__PURE__*/function (_react_1$default$Pure) {
    _inherits(_class, _react_1$default$Pure);

    var _super = _createSuper(_class);

    function _class(props) {
      _classCallCheck(this, _class);

      return _super.call(this, props);
    }

    _createClass(_class, [{
      key: "handleClick",
      value: function handleClick(onClick) {
        if (onClick) {
          onClick();
        }
      }
    }, {
      key: "renderBreadcrumbs",
      value: function renderBreadcrumbs() {
        var _this = this;

        var breadcrumbs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var classes = arguments.length > 1 ? arguments[1] : undefined;
        var crumbs = breadcrumbs.map(function (crumb) {
          var _onClick = crumb.onClick,
              title = crumb.title,
              left = crumb.left;
          return react_1.default.createElement(Text, {
            className: ['TitleBar__breadcrumb', classes === null || classes === void 0 ? void 0 : classes.breadcrumb, classes === null || classes === void 0 ? void 0 : classes.breadcrumbText],
            key: title,
            onClick: function onClick() {
              return _this.handleClick(_onClick);
            },
            style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.breadcrumb), styles === null || styles === void 0 ? void 0 : styles.breadcrumbText)
          }, left, title);
        });

        if (crumbs.length > 1) {
          for (var i = 0; i < Math.floor(crumbs.length / 2); i++) {
            var index = i * 2 - 1;
            crumbs.splice(index, 0, react_1.default.createElement(Text, {
              className: ['TitleBar__seperator', classes === null || classes === void 0 ? void 0 : classes.seperator],
              style: styles === null || styles === void 0 ? void 0 : styles.separator
            }, " | "));
          }
        }

        return crumbs;
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            after = _this$props.after,
            before = _this$props.before,
            breadcrumbs = _this$props.breadcrumbs,
            classes = _this$props.classes,
            model = _this$props.model,
            opts = _this$props.opts,
            title = _this$props.title,
            totalPrice = _this$props.totalPrice;
        return react_1.default.createElement(Frame, {
          className: ['TitleBar__container', classes === null || classes === void 0 ? void 0 : classes.container],
          style: styles === null || styles === void 0 ? void 0 : styles.container
        }, react_1.default.createElement(Frame, {
          className: ['TitleBar__inner', classes === null || classes === void 0 ? void 0 : classes.inner],
          style: styles === null || styles === void 0 ? void 0 : styles.inner
        }, before, react_1.default.createElement(Frame, {
          className: ['TitleBar__title-wrapper', classes === null || classes === void 0 ? void 0 : classes.titleWrapper],
          style: styles === null || styles === void 0 ? void 0 : styles.titleWrapper
        }, (opts === null || opts === void 0 ? void 0 : opts.breadcrumbs) !== false && react_1.default.createElement(Frame, {
          className: ['TitleBar__breadscrumb-container', classes === null || classes === void 0 ? void 0 : classes.breadcrumbsContainer],
          style: styles === null || styles === void 0 ? void 0 : styles.breadcrumbsContainer
        }, this.renderBreadcrumbs(breadcrumbs, classes)), (opts === null || opts === void 0 ? void 0 : opts.title) !== false && react_1.default.createElement(Text, {
          className: ['Titlebar__title', classes === null || classes === void 0 ? void 0 : classes.title],
          style: styles === null || styles === void 0 ? void 0 : styles.title
        }, title || model.name)), after));
      }
    }]);

    return _class;
  }(react_1.default.PureComponent);
};

exports.TitleBar = TitleBar;

var style = function style(theme) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;

  return {
    breadcrumb: Object.assign({
      color: (_a = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _a === void 0 ? void 0 : _a.secondary,
      fontSize: 18,
      textDecoration: 'none'
    }, (_b = theme === null || theme === void 0 ? void 0 : theme.TitleBar) === null || _b === void 0 ? void 0 : _b.breadcrumb),
    breadcrumbsContainer: Object.assign({
      display: 'flex',
      flexDirection: 'row',
      marginBottom: 5
    }, (_c = theme === null || theme === void 0 ? void 0 : theme.TitleBar) === null || _c === void 0 ? void 0 : _c.breadcrumbsContainer),
    breadcrumbLink: Object.assign({}, (_d = theme === null || theme === void 0 ? void 0 : theme.TitleBar) === null || _d === void 0 ? void 0 : _d.breadcrumbLink),
    breadcrumbText: Object.assign({}, (_e = theme === null || theme === void 0 ? void 0 : theme.TitleBar) === null || _e === void 0 ? void 0 : _e.breadcrumbText),
    container: Object.assign({
      display: 'flex',
      width: '100%',
      zIndex: 10
    }, (_f = theme === null || theme === void 0 ? void 0 : theme.TitleBar) === null || _f === void 0 ? void 0 : _f.container),
    inner: Object.assign(Object.assign(Object.assign({
      alignItems: 'center',
      boxSizing: 'border-box',
      display: 'flex'
    }, StyleUtils_1.default.margin('0 auto')), _defineProperty({
      maxWidth: (_g = theme === null || theme === void 0 ? void 0 : theme.Body) === null || _g === void 0 ? void 0 : _g.maxWidth,
      width: '100%'
    }, "@media (max-width: ".concat((_h = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _h === void 0 ? void 0 : _h.mobile, "px)"), {
      justifyContent: 'center'
    })), (_j = theme === null || theme === void 0 ? void 0 : theme.TitleBar) === null || _j === void 0 ? void 0 : _j.inner),
    seperator: Object.assign(Object.assign({
      color: (_k = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _k === void 0 ? void 0 : _k.secondary,
      fontSize: 16
    }, StyleUtils_1.default.padding('0 6px')), (_l = theme === null || theme === void 0 ? void 0 : theme.TitleBar) === null || _l === void 0 ? void 0 : _l.separator),
    title: Object.assign({
      fontSize: 35,
      fontWeight: '100',
      margin: 0,
      textTransform: 'uppercase'
    }, (_m = theme === null || theme === void 0 ? void 0 : theme.TitleBar) === null || _m === void 0 ? void 0 : _m.title),
    titleWrapper: Object.assign({
      display: 'flex',
      flexDirection: 'column'
    }, (_o = theme === null || theme === void 0 ? void 0 : theme.TitleBar) === null || _o === void 0 ? void 0 : _o.titleWrapper)
  };
};

exports.style = style;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var api = state.api,
      app = state.app;
  var configuration = api.configuration;
  var countryCode = app.countryCode;
  var db = new BrightsmithDb(api);
  var model = db.getCurrentModel();
  var totalPrice = db.calculateTotalPrice(configuration, model, countryCode);
  return {
    model: model,
    totalPrice: totalPrice
  };
};

exports.mapStateToProps = mapStateToProps;